import { useState } from "react";
import CoreTabBar from "../../../app/core/components/CoreTabBar/CoreTabBar.jsx";
import DocumentView from "./DocumentView/DocumentView.jsx";
import ActivityView from "./ActivityView/ActivityView.jsx";
import ActivityViewUser from "./ActivityView/ActivityViewUser.jsx";
import FilterDocument from "./DocumentView/FilterDocument.jsx";
import FilterActivity from "./ActivityView/FilterActivity.jsx";
import { useSelector } from "react-redux";
import { ROLE } from "../../../utils/constants/profiles.js";
import FilterActivityUser from "./ActivityView/FilterActivityUser.jsx";

const DashboardPage = () => {
  const appConfig = useSelector((state) => state.app.appConfig);
  const role = useSelector((state) => state.app.role);

  const dashboardActivityEnabled = appConfig?.modules?.dashboard?.activityView;

  const [selectedTab, setSelectedTab] = useState(
    dashboardActivityEnabled ? "attività" : "documenti"
  );
  const [filter, setFilter] = useState({
    adminId: "",
    studioId: "",
    userId: "",
  });

  const [filterTask, setFilterTask] = useState({
    adminId: "",
    studioId: "",
    userId: "",
    serviceId: "",
    practiceStatus: "",
    practiceId: "",
    startDate: "",
    endDate: "",
  });

  const [fileterUser, setFilterUser] = useState({
    practiceId: "",
    startDate: "",
    endDate: "",
  });

  const TABS_DASHBOARD = [
    { label: "Attività", tab: "attività" },
    { label: "Documenti", tab: "documenti" },
  ];

  return (
    <div className="flex flex-col">
      <div className="flex justify-between items-center space-x-4">
        <h2>Dashboard</h2>
        {dashboardActivityEnabled && (
          <CoreTabBar
            tab={TABS_DASHBOARD}
            setSelectedTab={setSelectedTab}
            selectedTab={selectedTab}
          />
        )}
        {selectedTab === "documenti" && (
          <FilterDocument filter={filter} setFilter={setFilter} />
        )}
        {selectedTab === "attività" &&
          (role !== ROLE.USER ? (
            <FilterActivity filter={filterTask} setFilter={setFilterTask} />
          ) : (
            <FilterActivityUser
              filter={fileterUser}
              setFilter={setFilterUser}
            />
          ))}
      </div>

      {selectedTab === "documenti" && (
        <DocumentView filter={filter} tab={selectedTab === "documenti"} />
      )}
      {selectedTab === "attività" && role !== ROLE.USER && (
        <ActivityView filter={filterTask} tab={selectedTab === "attività"} />
      )}
      {selectedTab === "attività" && role === ROLE.USER && (
        <ActivityViewUser
          filter={fileterUser}
          tab={selectedTab === "attività"}
        />
      )}
    </div>
  );
};

export default DashboardPage;
